import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrGuideCategory.ts
var t = () => e("guideCategory");
//#endregion
export { t as useTrGuideCategory };
